import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export const RevelationSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-cream" ref={ref} data-id="element-152">
      <div className="max-w-4xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 1
      }} className="text-center space-y-6 md:space-y-10" data-id="element-154">
          <h2 className="text-3xl md:text-5xl font-serif text-charcoal leading-tight" data-id="element-155">
            Descubrí que el secreto no está en "dejar la mente en blanco", sino
            en{' '}
            <span className="text-gold italic" data-id="element-156">darle a tus manos un ritmo</span>
            .
          </h2>

          <p className="text-lg md:text-xl text-charcoal/80 font-light leading-relaxed max-w-3xl mx-auto" data-id="element-157">
            Existe un estado mental llamado "Flow" (Flujo), donde el tiempo
            desaparece y el estrés se disuelve. La neurociencia ha confirmado
            que el macramé, por su naturaleza rítmica y simétrica, funciona como
            un "reseteo" para tu sistema nervioso.
          </p>

          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={isInView ? {
          scale: 1,
          opacity: 1
        } : {
          scale: 0.95,
          opacity: 0
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="mt-6 md:mt-12 p-6 md:p-12 border border-gold/30 bg-white/50 backdrop-blur-sm rounded-sm" data-id="element-158">
            <p className="text-xl md:text-2xl font-serif text-brown" data-id="element-159">
              He destilado este descubrimiento en <br data-id="element-160" />
              <span className="text-3xl md:text-4xl font-bold text-gold mt-4 block" data-id="element-161">
                "Nudos de Esperanza"
              </span>
            </p>
            <p className="mt-4 text-lg text-charcoal/70 uppercase tracking-widest text-sm" data-id="element-162">
              Un sistema diseñado no para hacer nudos, sino para reconstruir
              vidas.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};